import { Controller } from 'react-hook-form';
import { SidePanelRow, ToggleInput } from '@ui/src';
import { AuthorizationFormTypes } from './types';

import cn from './styles.module.css';

const WebhooksForm = ({
  control,
  onSubmit,
  children,
}: AuthorizationFormTypes): React.JSX.Element => (
  <form onSubmit={onSubmit} className={cn.details}>
    <div className={cn.brandColorsTitle}>Turnstile options</div>
    <SidePanelRow>
      <Controller
        control={control}
        name="publicRegistrationEnabled"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Public registration enabled"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    <SidePanelRow>
      <Controller
        control={control}
        name="turnstileEnabled"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Turnstile Enabled"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    {/* <SidePanelRow>
      <Controller
        control={control}
        name="turnstileForceEnabled"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Turnstile Force Enabled"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow> */}
    <div className={cn.brandColorsTitle}>Twillio options</div>
    <SidePanelRow>
      <Controller
        control={control}
        name="disableTwilioAutoThrottle"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Disable Throttle"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    <div className={cn.brandColorsTitle}>Locks options</div>
    <SidePanelRow>
      <Controller
        control={control}
        name="disableAutoLocks"
        render={({ field: { onChange, value, name } }) => (
          <ToggleInput
            name={name}
            title="Disable Auto lock"
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
          />
        )}
      />
    </SidePanelRow>
    {children}
  </form>
);

export default WebhooksForm;
